import {API} from "../api/axios";
const END_POINT = '/school/{school}/courses';
const END_POINT_CLASS = "/school/me/courses";
const END_POINT_COURSE = "/school/courses";
const END_POINT_COURSE_ADD = "/course";
const END_POINT_Courses = "/courses";

class CoursesService {
  getAll(params) {
    return API.get(END_POINT_COURSE, params)
  }
  getAllList(params) {
    return API.get(`/courses`,params)
  }
  create(data,id) {
    return API.post(`${END_POINT_COURSE}/${id}`, data);
  }
  add(params) {
    return API.post(END_POINT_COURSE_ADD,params);
}
  
}

export default new CoursesService();

